// ------
// Toggle mega menu class
// ------
const menuLinks = document.querySelectorAll('.menu__item.has-mega-menu');

const toggleMegaMenu = (toggle) => {
  document.body.classList.toggle('is-open-mega-menu', toggle);
};

menuLinks.forEach((el) => {
  el.addEventListener('mouseenter', () => {
    toggleMegaMenu(true);
  });

  el.addEventListener('mouseleave', () => {
    toggleMegaMenu(false);
  });
});

// ------
// Open Mega Menu
// ------

attachEvent('.menu__arrow', 'click', (ev) => {
  const parentElem = ev.target.closest('.menu__item');
  parentElem.classList.toggle('is-open-submenu');
  ev.preventDefault();
});

// ------
// Open Mega Menu Sub Menu
// ------

attachEvent('.mega-menu__arrow', 'click', (ev) => {
  const parentElem = ev.target.closest('.mega-menu__item');
  parentElem.classList.toggle('is-open-mega-submenu');
  ev.preventDefault();
});

// ------
// Close sub menu
// ------

attachEvent('.menu__back-btn', 'click', (ev) => {
  const parentElem = ev.target.closest('.menu__item');
  const parentMegaMenu = ev.target.closest('.mega-menu__item');

  if (parentMegaMenu) {
    parentMegaMenu.classList.remove('is-open-mega-submenu');
  } else {
    parentElem.classList.remove('is-open-submenu');
  }

  ev.preventDefault();
});
